import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import {CommonLibrary} from "../../../contexts/CommonContext";
import { DropDownListCustom, DropDownListCustomHandle } from "../../../components/DropDownlistCustom";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter
} from "@progress/kendo-react-grid";
import { ODataProvider } from "../../../contexts/ODataContext";
import { UserService,  RolesUserModel } from "../../../services/UserService";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";
import { Link, useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";

import { PermissionButton } from "../../../components/PermissionButton";

const ManageRole: React.FC = () => {

  // Define properties and hooks
  const userService = new UserService();
  const commonLibrary = new CommonLibrary();
  const { t } = useTranslation();
  const API_URL = config.API_URL;
  const searchList = {
    Label: t("general.search"),
    PlaceHolder: t("general.searchByTags"),
    TextField: "Description",
    KeyField: "RoleId",
    PageSize: 30,
    baseUrl: API_URL + "/odata/ProjectRoles?useCurrentFilter=false"
  }

  const location = useLocation();
  const { UserId, Username } = location.state as any;
  const projectRolesUrl = config.API_URL + "/odata/ProjectUserRoles?useCurrentFilter=false";
  const [value, setValue] = React.useState<any>([]);
  const dataGridRef = useRef<DataGridHandle>(null);
  const searchTagRef = useRef<DropDownListCustomHandle>(null);
  const [selectedItems, setSelectedItems] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const columns = [] as ColumnCustomProps[];
  columns.push({ field: "RoleName", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  
 
  const onSetValue = (event: DropDownListChangeEvent) => {
    setValue(event.target.value);
    console.log(event.target.value);
  }  

  const onSelectedItemsChange = (selectedItems: number[]) => {
    setSelectedItems(selectedItems);
  }

  const handleAddRoles = () => {
    const model: RolesUserModel = {
      ProjectId: commonLibrary.ProjectId,
      ObjectIds: [value.RoleId],
      TargetId: UserId
    }
    userService.AddRolesToUser(model).then(() => {
      dataGridRef.current?.refreshData();
    });
  }

  const handleRemoveRoles = () => {
    if (selectedItems.length > 0) {
      setShow(true);
    }
  }

  const handleConfirm = () => {
    setShow(false);
    const model: RolesUserModel = {
      ProjectId: commonLibrary.ProjectId,
      ObjectIds: selectedItems,
      TargetId: UserId
    }
    userService.RemoveRolesFromUser(model).then(() => {
      dataGridRef.current?.refreshData();
    });
  }

  React.useEffect(() => {   
   
    dataGridRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "UserId",
          operator: "eq",
          value: UserId
        }
      ]
    });   
  }, []);

  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/users">
          <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" />
          <Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">
          <div>
        <h5 className="title"><Trans>configuration.users.manageRolesTo</Trans> {Username}</h5>
      </div>
      <Row className="pt-4">
        <Col sm={5} >      
          <ODataProvider baseUrl={searchList.baseUrl} loadingContent=".k-dropdownlist">
            <DropDownListCustom ref={searchTagRef} KeyField={searchList.KeyField} Label={searchList.Label} PageSize={searchList.PageSize} PlaceHolder={searchList.PlaceHolder} TextField={searchList.TextField} onChange={onSetValue} />
          </ODataProvider>
          </Col>
          <Col className="pt-4" sm={{span:2, offset:5}}>
        <PermissionButton code="configuration_users_roles" mode="edit">
          <button className="btn btn-primary" onClick={handleAddRoles}><Trans>configuration.users.addRoleTo</Trans>{Username}</button>
          </PermissionButton>
          </Col>
      </Row>      
      </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">
      <Row>
        <Col sm={12}>
          <ODataProvider baseUrl={projectRolesUrl} loadingContent=".k-grid-content">
            <DataGridCustom PermissionButtonCode="configuration_users_roles" ShowRemoveButton={true} onRemoveButtonClick={handleRemoveRoles} ref={dataGridRef} DataItemKey="RoleId" Columns={columns} onSelectedItemsChange={onSelectedItemsChange} autoBind={false} />
          </ODataProvider>
        </Col>
      </Row>
      </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><Trans>general.titleRemoveMessage</Trans></Modal.Title>
        </Modal.Header>
        <Modal.Body><Trans>general.removeMessage</Trans></Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={handleClose}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
            <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageRole;
